// One tab per browser leads a job (Phase 1, 2026-09-30).
//
// Every open tab is a full client; work that only needs doing once per browser (creating order cards
// from new mail, background alerts) was done by every tab. The Web Locks API grants a named lock to one
// tab at a time and hands it to the next queued tab the moment the holder closes, so the job always has
// exactly one leader while any tab is open. Browsers without Web Locks run the job in every tab, as
// before.
export function claimTabLeader(name: string, onLead: () => void): () => void {
  const locks = typeof navigator !== 'undefined' ? (navigator as any).locks : undefined;
  if (!locks?.request) {
    onLead();
    return () => {};
  }
  let release: () => void = () => {};
  const held = new Promise<void>((resolve) => { release = resolve; });
  const abort = typeof AbortController !== 'undefined' ? new AbortController() : null;
  let stopped = false;
  locks
    .request(name, abort ? { signal: abort.signal } : {}, () => {
      if (!stopped) onLead();
      return held; // kept until this tab stops the job or closes
    })
    .catch(() => { /* aborted while queued, or the lock was refused — nothing to do */ });
  return () => {
    stopped = true;
    abort?.abort();
    release();
  };
}
